import { Button, Modal } from 'antd';
import React from 'react';
import BookingApi from '../../../functions/api/booking/BookingApi';
import PartnerApi from '../../../functions/api/partner/PartnerApi';
import MyUtil from '../../../functions/MyUtil';

export default class ButtonFormatter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      edit: false,
      detailBooking: '',
      partner: '',
    };
    this.toggle = this.toggle.bind(this);
  }

  async toggle() {
    const booking = this.props.row;
    let { detailBooking } = this.state;
    const { modal } = this.state;

    if (!detailBooking) {
      detailBooking = await BookingApi.getBookingByCode(booking.book_code);
      const partner = await PartnerApi.getDetailPartner(booking.part_id);

      this.setState({ detailBooking, partner });
    }
    this.setState({ modal: !modal });
  }

  handleOk = () => {
    this.setState({
      modal: false,
    });
  };
  handleCancel = () => {
    this.setState({
      modal: false,
    });
  };

  render() {
    const booking = this.state.detailBooking;
    const { modal } = this.state;

    return (
      <div className="div-edit-booking">
        <Button onClick={this.toggle}>
          <i className="fa fa-eye"></i>
        </Button>
        <Modal
          title="Chi tiết đặt xe"
          visible={modal}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          {booking && (
            <>
              <b>
                <div className="title-detail">Mã booking:</div>
              </b>
              <span>{booking.book_code} </span>
              <br />
              <b>
                <div className="title-detail">Thành phố:</div>
              </b>
              <span style={{ color: 'red', fontWeight: '500' }}>
                {booking.city_name}
              </span>
              <br />
              <b>
                <div className="title-detail">Tên khách hàng:</div>
              </b>
              <span>{booking.cstm_name}</span>

              <div style={{ display: '-webkit-inline-box' }}>
                <div className="title-detail">
                  <b>Địa chỉ nhận xe:</b>
                </div>
                <div style={{ width: '209px' }}>{booking.cstm_deli_addr}</div>
              </div>
              <br />
              <b>
                <div className="title-detail">Ngày thuê</div>
              </b>
              <span>
                {MyUtil.getDatetimeFormatCrta(new Date(booking.book_rent_date))}
              </span>
              <br />
              <b>
                <div className="title-detail">Ngày trả</div>
              </b>
              <span>
                {MyUtil.getDatetimeFormatCrta(
                  new Date(booking.book_retun_date)
                )}
              </span>
              <br />
              <b>
                <div className="title-detail">Số ngày thuê</div>
              </b>
              <span>{booking.book_day_num} ngày</span>
              <br />
              <b>
                <div className="title-detail">Loại xe:</div>
              </b>
              <span>{booking.vhc_type_name}</span>
              <br />
              <div style={{ display: '-webkit-inline-box' }}>
                <div className="title-detail">
                  <b>Tên xe:</b>
                </div>
                <div style={{ width: '209px', color: 'red' }}>
                  {booking.vhc_part_name}
                </div>
              </div>
              <br />
              <div className="title-detail">
                <b>Ghi chú:</b>
              </div>
              <div style={{ width: '209px' }}>{booking.book_note}</div>

              <div style={{ marginLeft: '10px' }}>
                <b>
                  <span className="title-detail-1">Chi tiết giá:</span>
                </b>
                <br />
                <b>
                  <span className="title-detail-1">
                    {
                      booking['book_prie_detl'][0]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </span>
                </b>
                <span>
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][0]['detl_prie_tota']
                  )}{' '}
                  VNĐ/{booking['book_day_num']} ngày{' '}
                </span>
                <br />
                <b>
                  <span className="title-detail-1">
                    {
                      booking['book_prie_detl'][1]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </span>
                </b>
                <span>
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][1]['detl_prie_tota']
                  )}{' '}
                  VNĐ{' '}
                </span>
                <br />
                <b>
                  <span className="title-detail-1">
                    {
                      booking['book_prie_detl'][2]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </span>
                </b>
                <span>
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][2]['detl_prie_tota']
                  )}{' '}
                  VNĐ{' '}
                </span>
                <br />
                <b>
                  <span className="title-detail-1">
                    {
                      booking['book_prie_detl'][3]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </span>
                </b>
                <span>
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][3]['detl_prie_tota']
                  )}{' '}
                  VNĐ{' '}
                </span>
                <br />
                <b>
                  <div className="title-detail-1">
                    {
                      booking['book_prie_detl'][4]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </div>
                </b>
                <span>
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][4]['detl_prie_tota']
                  )}{' '}
                  VNĐ{' '}
                </span>
                <br />
                <b>
                  <div className="title-detail-1">
                    {
                      booking['book_prie_detl'][5]['book_prie_type'][
                        'book_prie_type_name'
                      ]
                    }
                    :
                  </div>
                </b>
                <span>
                  -
                  {MyUtil.currencyFormat(
                    booking['book_prie_detl'][5]['detl_prie_tota']
                  )}{' '}
                  VNĐ ({booking['promo_code']} -{' '}
                  {booking.promo_val < 100
                    ? `${booking.promo_val}%`
                    : `${MyUtil.currencyFormat(booking.promo_val)} VNĐ`}
                  )
                </span>
                <br />
                <b>
                  <div className="title-detail-1">Tổng tiền:</div>
                </b>
                <span style={{ fontSize: '20px', color: 'red' }}>
                  {MyUtil.currencyFormat(booking.book_prie_tota)}
                </span>
                <br />
              </div>
            </>
          )}
        </Modal>
      </div>
    );
  }
}
